// extracted by mini-css-extract-plugin
export default {"container":"HomeCircleIcon_container__bJNkX","iconContainer":"HomeCircleIcon_iconContainer__GVg7g","paperclip":"HomeCircleIcon_paperclip__midcP"};